import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

const router = new Router({
  routes: [
    {
    path: '/',
    component: Layout,
    children: [
      {
      path: '',
      name: 'Home',
      meta: {
        title: "语音合成"
      },
      component: () =>
        import('@/views/system/home/index.vue')
    },]
  },
     {
    path: '/Home',
    component: Layout,
    children: [
      {
      // path: '/home/index/:userId/:userName/:platForm/:oriApi',
      path:'/home/index',
      name: 'Home',
      meta: {
        title: "语音合成"
      },
      component: () =>
        import('@/views/system/home/index.vue')
    },
     {
      // path: '/home/index/:userId/:userName/:platForm/:oriApi',
      path:'/home/h5Index',
      name: 'Home',
      meta: {
        title: "语音合成"
      },
      component: () =>
        import('@/views/system/home/h5Index.vue')
    },
  ]
  },
  {
    path: '/faceDatabase',
    component: Layout,
    children: [{
      // path: '/faceDatabase/index/:userId/:userName/:platForm/:oriApi',
      path:'/faceDatabase/index',
      // name: 'faceDatabase',
      meta: {
        title: "人脸库"
      },
      component: () =>
        import('@/views/system/faceDatabase/index.vue')
    },
    {
      // path: '/faceDatabase/index/:userId/:userName/:platForm/:oriApi',
      path:'/faceDatabase/h5Index',
      // name: 'faceDatabase',
      meta: {
        title: "人脸库"
      },
      component: () =>
        import('@/views/system/faceDatabase/h5Index.vue')
    },
  ]
  },
   {
    path: '/VoiceRecognition',
    component: Layout,
    children: [{
      // path: '/VoiceRecognition/index/:userId/:userName/:platForm/:oriApi',
      path:'/VoiceRecognition/index',
      name: 'VoiceRecognition',
      meta: {
        title: "语音识别"
      },
      component: () =>
        import('@/views/system/VoiceRecognition/index.vue')
    },
    {
      // path: '/VoiceRecognition/index/:userId/:userName/:platForm/:oriApi',
      path:'/VoiceRecognition/h5Index',
      name: 'VoiceRecognition',
      meta: {
        title: "语音识别"
      },
      component: () =>
        import('@/views/system/VoiceRecognition/h5Index.vue')
    },
  ]
  },
   {
    path: '/imageType',
    component: Layout,
    children: [{
    //  path: '/imageType/index/:userId/:userName/:platForm/:oriApi',
      path:'/imageType/index',
      name: 'imageType',
      meta: {
        title: "图片类型"
      },
      component: () =>
        import('@/views/system/imageType/index.vue')
    },
    {
    //  path: '/imageType/index/:userId/:userName/:platForm/:oriApi',
      path:'/imageType/h5Index',
      name: 'imageType',
      meta: {
        title: "图片类型"
      },
      component: () =>
        import('@/views/system/imageType/h5Index.vue')
    },
  ]
  },
   {
    path: '/imageLibrary',
    component: Layout,
    children: [{
      // path: '/imageLibrary/index/:userId/:userName/:platForm/:oriApi',
      path:'/imageLibrary/index',
      name: 'imageLibrary',
      meta: {
        title: "图片库"
      },
      component: () =>
        import('@/views/system/imageLibrary/index.vue')
    },
    {
      // path: '/imageLibrary/index/:userId/:userName/:platForm/:oriApi',
      path:'/imageLibrary/h5Index',
      name: 'imageLibrary',
      meta: {
        title: "图片库"
      },
      component: () =>
        import('@/views/system/imageLibrary/h5Index.vue')
    },
  ]
  },
   {
    path: '/deepseek',
    component: Layout,
    children: [{
      //  path: '/deepseek/index/:userId/:userName/:platForm/:oriApi',
      path:'/deepseek/index',
      name: 'deepseek',
      meta: {
        title: "智能AI"
      },
      component: () =>
        import('@/views/system/deepseek/index.vue')
    },
    {
      //  path: '/deepseek/index/:userId/:userName/:platForm/:oriApi',
      path:'/deepseek/h5Index',
      name: 'h5Index',
      meta: {
        title: "智能AI"
      },
      component: () =>
        import('@/views/system/deepseek/h5Index.vue')
    },
  ]
  },
  
  // 积分商城
/*   {
    path: '/integral',
    component: Layout,
    children: [
      {
        path: '',
        meta: {
          title: "积分商城"
        },
        component: () =>
          import('@/views/system/integral/index.vue')
      }, {
        path: '/integral/detail/:Id',
        meta: {
          title: "商品详情"
        },
        component: () =>
          import('@/views/system/integral/detail.vue')
      }]
  }, */
  ],
  mode: 'history',
});

// 动画效果
router.beforeEach((to, from, next) => {
  console.log(to.path)
  console.log(from.path)

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.path == from.path || ((to.path == '/' || to.path == '/serve' || to.path == '/center') && (from.path == '/' || from.path == '/serve' || from.path == '/login' || from.path == '/village'))) {
    store.commit('UPDATE_DIRECTION', "none")
  } else if (to.path.indexOf(from.path) != -1 || (from.name && to.name.indexOf(from.name) != -1)) {
    store.commit('UPDATE_DIRECTION', "forward")
  } else {
    store.commit('UPDATE_DIRECTION', "reverse")
  }
  next();
})

export default router
